<!-- Root container: relative to position background absolutely -->
<div class="relative w-full h-screen overflow-hidden text-white">
  
  <!-- Background Carousel (STAYS FIXED) -->
  <div class="absolute top-0 left-0 w-full h-full z-0">
    <div *ngFor="let img of images; let i = index"
         class="absolute inset-0 duration-1000 transition-opacity"
         [ngClass]="{ 'opacity-100': currentIndex === i, 'opacity-0': currentIndex !== i }">
      <img [src]="img" class="w-full h-full object-cover brightness-110" />
    </div>
  </div>

  <!-- Scrollable content (ONLY THIS PART MOVES) -->
  <div class="relative z-10 overflow-y-auto h-screen bg-gradient-to-t from-black/60 to-transparent px-4 py-5">
    <div class="flex flex-col items-center w-full max-w-6xl mx-auto space-y-6 pb-10">
      
      <!-- Logo -->
      <img src="assets/collegiatemobile-home/logo-white.png"
           alt="Collegiate Mobile Logo"
           class="h-20 md:h-18 w-auto" />

      <!-- Heading -->
      <div class="text-4xl sm:text-5xl md:text-7xl font-bold italic uppercase text-center"
           style="font-family: 'Alumni Sans SC';">
        SUPPORT YOUR SCHOOL<br />
        JUST BY PAYING YOUR<br />PHONE BILL
      </div>

      <!-- Subheading -->
      <p class="text-base sm:text-lg md:text-xl font-bold italic text-center"
         style="font-family: 'Poppins';">
        A direct portion of your bill goes to your school<br />
        when you switch to Collegiate Mobile.
      </p>

      <!-- Search Form -->
      <div class="flex flex-col sm:flex-row items-center justify-center w-full sm:w-auto gap-2 px-4 sm:px-0">
        <form #emailForm="ngForm" (ngSubmit)="callvisitoranalytics()">
          <input type="text"
                 name="email"
                 placeholder="Enter your school"
                 class="w-full text-2xl sm:text-3xl text-black p-4 rounded-md focus:outline-none"
                 [(ngModel)]="email"
                 (ngModelChange)="onSearchChange($event)" />
        </form>
      </div>

      <!-- Search Results Header -->
      <div *ngIf="email && filteredSchools.length > 0"
           class="w-full text-left text-white text-xl mt-6">
        Showing {{ filteredSchools.length }} school(s) that match "<strong>{{ email }}</strong>"
      </div>

      <!-- School Cards -->
      <div *ngIf="email && filteredSchools.length > 0"
           class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full mt-4">
        <div class="card bg-white text-black p-4 rounded-md shadow-md"
             *ngFor="let school of filteredSchools">
          <h2 class="text-lg font-bold">{{ school.name }}</h2>
          <p class="text-gray-600">{{ school.city }}</p>
          <div class="flex items-center gap-2 mt-3 mb-4">
            <div *ngFor="let color of school.colors"
                 class="h-8 w-8 rounded-md"
                 [ngClass]="color"></div>
          </div>
          <button class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded w-full">
            Get Started!
          </button>
        </div>
      </div>

      <!-- No Results Message -->
      <p *ngIf="email && filteredSchools.length === 0"
         class="text-center text-red-400 font-semibold mt-6">
        No schools found matching "{{ email }}"
      </p>

      <!-- I don't see my school -->
      <a href="#" class="text-blue-400 underline mt-6"
         *ngIf="email">I don't see my school listed.</a>

    </div>
  </div>
</div>
